import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTelegramLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14,
		cy: 14,
		r: 14,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.40328 12.1167C8.0006 12.7175 6.55944 13.3349 5.24158 14.047C4.55343 14.5413 5.46802 14.891 6.32608 15.2189C6.46246 15.2711 6.59741 15.3226 6.7243 15.3741C6.82991 15.406 6.93727 15.4396 7.04607 15.4736C8.00038 15.7718 9.06443 16.1044 9.9909 15.6041C11.5128 14.7464 12.949 13.7549 14.3842 12.7641C14.8544 12.4394 15.3244 12.1149 15.7974 11.7952C15.8196 11.7813 15.8445 11.7653 15.8719 11.748C16.2747 11.4918 17.1809 10.9156 16.8457 11.7095C16.0531 12.5598 15.2042 13.3125 14.3507 14.0693C13.7755 14.5794 13.1981 15.0913 12.6345 15.6362C12.1437 16.0274 11.6339 16.8143 12.1836 17.3622C13.4495 18.2316 14.7353 19.08 16.0203 19.9279C16.4385 20.2038 16.8566 20.4796 17.2739 20.7562C17.9811 21.3101 19.0864 20.862 19.2419 19.9964C19.311 19.5982 19.3804 19.2001 19.4498 18.8019C19.8335 16.6014 20.2173 14.4 20.5563 12.1923C20.6024 11.8459 20.6546 11.4996 20.7069 11.1532C20.8335 10.3135 20.9604 9.47274 21 8.62851C20.8979 7.78598 19.8566 7.97126 19.2771 8.16072C16.2987 9.27259 13.3499 10.4669 10.4128 11.6822C10.0801 11.8268 9.74284 11.9713 9.40328 12.1167Z",
		fill: "#4469C6"
	})]
});
export default SvgTelegramLogo;
